
import React, { useState } from 'react'
import { isMobile, priceFormat } from '../../helpers/helpers';
import Radio from '../Forms/Radio';
import CONSTANTS from '../../Constants';
import ComplementaryOperations from './ComplementaryOperations';

const ForfaitRevisionItem = (props) => {
    const { forfait, open } = props

    const [ShowDetail, setShowDetail] = useState(false)
    const checkedClass = forfait.isSelected ? 'selected' : ''

    const onForfaitChecked = (e) => {
        props.addToCheckedForfaits(forfait)
    }
    const handleComplentaryOperationCheked = (mandOperation) => {
        props.handleMandatoryOperations(mandOperation)
    }
    const arrowDirectionClass = ShowDetail ? 'arrowUp' : 'arrowDown'
    return (
        <>
            <li className="forfait-item">
                <div className='forfait-container'>
                    <div className='forfait-block'>
                        <Radio
                            name='RevisionForfaits'
                            id={forfait.Items[0].Ref}
                            label={forfait.Libelle}
                            value={forfait.Items[0].Ref}
                            isChecked={open}
                            onChange={onForfaitChecked}
                        />
                        {!isMobile() && <div className={`forfait-prix ${checkedClass}`}>{priceFormat(forfait.Items[0].Prix)} <span className="tax-text"> {CONSTANTS.LABELS.needs_basket_label2}</span></div>}
                        {forfait.Comments.length > 0 && <div tabIndex="0" className={`forfait-detail-link ${arrowDirectionClass}`} onClick={() => setShowDetail(!ShowDetail)}>{CONSTANTS.LABELS.common_v2_detail}</div>}
                    </div>
                    {ShowDetail && <div className='forfait-details'>
                        {forfait.Comments.map(comment => {
                            return (
                                <p key={comment.Order} className='detail'>{comment.Text}</p>
                            )
                        })}
                    </div>}
                    {isMobile() && <div className={`forfait-prix ${checkedClass}`}>{priceFormat(forfait.Items[0].Prix)}<span className="tax-text"> {CONSTANTS.LABELS.needs_basket_label2}</span></div>}
                </div>
            </li>
            {
                !isMobile() && open && forfait.Operations.length > 0 && <ComplementaryOperations
                    forfait={forfait}
                    complementaryOperations={forfait.Operations}
                    forfaitPrice={forfait.Items[0].Prix}
                    onComplementaryOperationChecked={handleComplentaryOperationCheked}
                />
            }
        </>
    );
}

export default ForfaitRevisionItem